import type { Messages } from '../catalogue.en'

export const egisz: Partial<Messages> = {
  "externalModule.egisz.history.confirmSelected": "להסיר את חתימת התפקיד הזה מ־{count} מסמכים שנבחרו? החתימה האחרת וכל ההיסטוריה יישמרו.",
  "externalModule.egisz.signing.expiredWarning": "תוקף התעודה פג בעת שמירת החתימה. השליחה מותרת.",
  "externalModule.egisz.signing.chainNotice": "החתימה תואמת ל־XML. אמון בשרשרת התעודה וביטול התעודה אינם נבדקים.",
  "externalModule.egisz.signing.identityWarning": "פרטי התעודה שונים מפרטי המסמך. ניתן לשלוח לנטְריקה.",
  "externalModule.egisz.signing.state": "{role}: {state}. {fact} {warning}",
  "externalModule.egisz.signing.stamp": "נשמרה {saved}; התעודה בתוקף עד {expires}.",
  "externalModule.egisz.rowAction": "{action}: {document}",
  "externalModule.egisz.organizationSignatureShort": "חתימת ארגון",
  "externalModule.egisz.doctorSignatureShort": "חתימת רופא",
  "externalModule.egisz.signing.unnamedCertificate": "תעודה ללא שם",
  "externalModule.egisz.prepare.field.conditionMapping": "מיפוי הפרוטוקול ← מצב המטופל (NSI 11.1006)",
  "externalModule.egisz.prepare.field.condition": "ייעוץ ← מצב המטופל",
  "externalModule.egisz.mapping.condition": "מצב המטופל (NSI 11.1006)",
  "externalModule.egisz.mapping.conditionMissing": "לא נבחר",
  "externalModule.egisz.prepare.organizationOID": "יש למלא את OID הארגון הרפואי (FRMO) בפרטי הארגון ברוסיה.",
  "externalModule.egisz.documentLabel": "{patient}, {date}",
  "externalModule.egisz.workplaceLabel": "{name}, {branch}, {position}",
  "externalModule.egisz.releaseLabel": "{name} ({version})",
  "externalModule.egisz.documentOption": "{type} {number}",

  "externalModule.egisz.downloadXML": "הורדת XML מדויק",
  "externalModule.egisz.retry": "ניסיון חוזר לשליחה שנדחתה",
  "externalModule.egisz.signing.doctor": "חתימה כרופא המטפל",
  "externalModule.egisz.signing.organization": "חתימה בשם הארגון",
  "externalModule.egisz.signing.certificate": "תעודת חתימה",
  "externalModule.egisz.signing.chooseCertificate": "בחירת תעודה",
  "externalModule.egisz.signing.stop": "עצירת החתימה",
  "externalModule.egisz.signing.pending": "החתימה מתבצעת. יש לפעול לפי ההנחיות ב־CryptoPro.",
  "externalModule.egisz.signing.saved": "החתימה נשמרה",
  "externalModule.egisz.signing.stopped": "החתימה נעצרה. חתימות שכבר נשמרו נשארות. יש לרענן את המסמכים לפני המשך העבודה.",
  "externalModule.egisz.signing.saveFailed": "לא התקבל אישור לשמירת החתימה. יש לרענן את המסמך לפני ניסיון נוסף. שאר המסמכים לא נחתמו.",
  "externalModule.egisz.signing.pluginUnavailable": "CryptoPro אינו זמין. יש לבדוק את התקנתו ואת הרחבת הדפדפן, ואז לטעון מחדש את הדף.",
  "externalModule.egisz.signing.certificateUnavailable": "התעודה שנבחרה אינה זמינה, אינה תקפה או שאין לה מפתח פרטי נתמך. יש לבחור תעודה אחרת.",
  "externalModule.egisz.signing.payloadChanged": "המסמך השתנה. יש לרענן אותו ולבדוק את הגרסה החדשה לפני החתימה.",
  "externalModule.egisz.signing.busy": "פעולת חתימה מקומית אחרת עדיין מתבצעת.",
  "externalModule.egisz.signing.failed": "CryptoPro לא השלים את החתימה או את האימות. התהליך נעצר; המסמכים הבאים לא נחתמו.",
  "externalModule.egisz.back": "חזרה לרשימה",
  "externalModule.egisz.document": "מסמך",
  "externalModule.egisz.version": "גרסה",
  "externalModule.egisz.created": "הוכן",
  "externalModule.egisz.remd": "רישום REMD",
  "externalModule.egisz.federalStatus": "סטטוס פדרלי {status}",
  "externalModule.egisz.checkedAt": "נבדק {date}",
  "externalModule.egisz.signedAt": "נחתם {date}",
  "externalModule.egisz.lastAttempt": "{operation}, {date}",
  "externalModule.egisz.attemptStatus": "קוד תשובה {status}",
  "externalModule.egisz.attemptFailed": "כשל תעבורה",
  "externalModule.egisz.menuFor": "פעולות: {document}",
  "externalModule.egisz.downloadDoctorSignature": "הורדת חתימת הרופא",
  "externalModule.egisz.downloadOrganizationSignature": "הורדת חתימת הארגון",
  "externalModule.egisz.removeDoctorSignature": "ביטול חתימת הרופא",
  "externalModule.egisz.removeOrganizationSignature": "ביטול חתימת הארגון",
  "externalModule.egisz.signing.waiting": "ממתין לחתימה",
  "externalModule.egisz.signing.signing": "חותם…",
  "externalModule.egisz.signing.failedRow": "החתימה נכשלה",
  "externalModule.egisz.signing.skipped": "דולג: התפקיד הזה אינו יכול לחתום עליו",
  "externalModule.egisz.signing.summary": "נשמרו {saved} מתוך {total} חתימות. דולגו: {skipped}.",
  "externalModule.egisz.signing.reading": "קורא תעודות…",
  "externalModule.egisz.signing.noCertificate": "תחילה יש לבחור תעודת חתימה מעל הטבלה.",
  "externalModule.egisz.title": "מערכת EGISZ",
  "externalModule.egisz.description": "מסמכי ייעוץ, חתימות ורישום ב־REMD",
  "externalModule.egisz.patient": "מטופל",
  "externalModule.egisz.author": "רופא",
  "externalModule.egisz.careAt": "מועד הייעוץ",
  "externalModule.egisz.state": "משלוח",
  "externalModule.egisz.registration": "מספר רישום ב־REMD",
  "externalModule.egisz.unsigned": "לא נחתם",
  "externalModule.egisz.doctorSignature": "חתימת הרופא",
  "externalModule.egisz.organizationSignature": "חתימת הארגון",
  "externalModule.egisz.empty": "אין מסמכים מוכנים",
  "externalModule.egisz.loading": "טעינת מסמכים…",
  "externalModule.egisz.loadFailed": "לא ניתן לטעון את המסמכים.",
  "externalModule.egisz.unavailable": "המסמך אינו זמין.",
  "externalModule.egisz.refresh": "רענון",
  "externalModule.egisz.actions": "פעולות",
  "externalModule.egisz.xml": "XML מוכן",
  "externalModule.egisz.showXML": "הצגת ה־XML המדויק",
  "externalModule.egisz.send": "שליחה ל־Netrika",
  "externalModule.egisz.checkStatus": "בדיקת מצב ב־REMD",
  "externalModule.egisz.queuedNotice": "נוסף לתור המשלוח. אין בכך אישור רישום ב־REMD.",
  "externalModule.egisz.statusNotice": "בקשת המצב הושלמה. הרישום מאושר רק באמצעות מספר הרישום השמור של REMD.",
  "externalModule.egisz.disabled": "המודול מושבת. ניתן לעיין במסמכים השמורים.",
  "externalModule.egisz.failed": "לא ניתן לאשר את תוצאת הפעולה. יש לרענן את המסמך לפני ניסיון נוסף.",
  "externalModule.egisz.conflict": "המסמך השתנה. יש לרענן ולבדוק אותו שוב.",
  "externalModule.egisz.locked": "ראיות המשלוח השמורות אינן מאפשרות שינוי זה. יש לבדוק את המצב הנוכחי.",
  "externalModule.egisz.notReady": "חסרים נתוני חובה במסמך או בחיבור.",
  "externalModule.egisz.signatureInvalid": "החתימה אינה תואמת למסמך או לחותם המורשה.",
  "externalModule.egisz.verifierUnavailable": "אימות החתימה אינו זמין.",
  "externalModule.egisz.validatorUnavailable": "בדיקת המסמך אינה זמינה.",
  "externalModule.egisz.payloadStoreUnavailable": "אחסון המסמכים אינו זמין.",
  "externalModule.egisz.unsent": "לא נשלח",
  "externalModule.egisz.queued": "בתור",
  "externalModule.egisz.sending": "בשליחה",
  "externalModule.egisz.acknowledged": "התקבל ב־Netrika",
  "externalModule.egisz.rejected": "נדחה",
  "externalModule.egisz.uncertain": "תוצאת המשלוח אינה ידועה",
  "externalModule.egisz.settings.title": "חיבור ל־Netrika",
  "externalModule.egisz.settings.edit": "עריכת החיבור",
  "externalModule.egisz.settings.save": "שמירת החיבור",
  "externalModule.egisz.settings.cancel": "ביטול השינויים",
  "externalModule.egisz.settings.unsaved": "הגדרות חיבור ל־Netrika שלא נשמרו",
  "externalModule.egisz.settings.discard": "לבטל את השינויים בחיבור?",
  "externalModule.egisz.settings.keep": "המשך עריכה",
  "externalModule.egisz.settings.reload": "טעינת ההגדרות השמורות במקום הטיוטה",
  "externalModule.egisz.settings.reloadFailed": "לא ניתן לטעון את ההגדרות. השינויים נשמרו בטופס.",
  "externalModule.egisz.settings.sources": "נדרשת הרשאת קריאת עובדים למיפוי מקומות עבודה.",
  "externalModule.egisz.settings.iemkUrl": "כתובת שירות IEMK",
  "externalModule.egisz.settings.eventLogUrl": "כתובת שירות EventLog",
  "externalModule.egisz.settings.lpu": "מזהה הארגון ב־Netrika",
  "externalModule.egisz.settings.systemOid": "OID המערכת ב־Netrika",
  "externalModule.egisz.settings.misNumber": "מספר מערכת המידע במזהי CDA",
  "externalModule.egisz.settings.misInstanceNumber": "מספר מופע מערכת המידע",
  "externalModule.egisz.settings.protocol": "גרסת פרוטוקול שפורסמה",
  "externalModule.egisz.settings.workplace": "מקום עבודת הרופא",
  "externalModule.egisz.settings.department": "מזהה המחלקה ב־Netrika",
  "externalModule.egisz.settings.doctor": "מזהה הרופא ב־Netrika",
  "externalModule.egisz.settings.add": "הוספת התאמה למקום עבודה",
  "externalModule.egisz.settings.remove": "הסרת ההתאמה",
  "externalModule.egisz.settings.systemGuid": "מפתח System GUID",
  "externalModule.egisz.settings.eventLogToken": "אסימון EventLog",
  "externalModule.egisz.settings.retained": "מפתח שמור. השאירו את השדה ריק כדי לשמור אותו.",
  "externalModule.egisz.settings.required": "טרם נשמר מפתח. הוא דרוש לשליחה ולא להכנת XML.",
  "externalModule.egisz.settings.sourceUnavailable": "הבחירה השמורה אינה זמינה",
  "externalModule.egisz.settings.hint": "שמרו את מזהי המסמך והגדרות החיבור לפי הצורך. שמירת הגדרות אינה שולחת מסמכים.",
  "externalModule.egisz.journal.title": "יומן ההחלפה",
  "externalModule.egisz.journal.operation": "פעולה",
  "externalModule.egisz.journal.started": "התחלה",
  "externalModule.egisz.journal.finished": "סיום",
  "externalModule.egisz.journal.response": "תשובת הספק השמורה",
  "externalModule.egisz.journal.details": "בקשת פרטי מצב",
  "externalModule.egisz.journal.transportFailed": "ההעברה נכשלה; ייתכן שהתוצאה אינה ידועה",
  "externalModule.egisz.journal.unfinished": "לא נשמר אישור סיום",
  "externalModule.egisz.journal.message": "הודעת הספק",
  "externalModule.egisz.journal.empty": "אין ניסיונות החלפה",
  "externalModule.egisz.settings.invalidCredentials": "מבנה המפתח אינו תקין. יש לבדוק את System GUID ואת אסימון EventLog שהוזנו.",
  "externalModule.egisz.history.title": "היסטוריית חתימות",
  "externalModule.egisz.history.role": "תפקיד החתימה",
  "externalModule.egisz.history.created": "מועד שמירת החתימה",
  "externalModule.egisz.history.expires": "תוקף התעודה",
  "externalModule.egisz.history.current": "חתימה נוכחית",
  "externalModule.egisz.history.retained": "חתימה קודמת שמורה",
  "externalModule.egisz.history.download": "הורדת מכל החתימה",
  "externalModule.egisz.history.remove": "ביטול החתימה המקומית",
  "externalModule.egisz.history.confirm": "לבטל את החתימה המקומית שנבחרה? המכל שלה יישמר בהיסטוריה. פעולה זו אינה מבטלת מסמך ב־REMD.",
  "externalModule.egisz.history.keep": "השארת החתימה",
  "externalModule.egisz.history.removed": "החתימה המקומית בוטלה. חתימה חדשה דורשת פעולה מפורשת של החותם.",
  "externalModule.egisz.history.empty": "אין חתימות שמורות",
  "externalModule.egisz.sources.branch": "סניף",
  "externalModule.egisz.sources.prepare": "הכנת מסמך REMD",
  "externalModule.egisz.prepare.unsaved": "בחירת נתונים ל־REMD שלא נשמרה",
  "externalModule.egisz.prepare.discard": "לבטל את בחירת הנתונים להכנה?",
  "externalModule.egisz.prepare.description": "בחרו את הפרטים המנהליים העדכניים לצירוף. התוכן הקליני ותוצאת המחלה נלקחים מהפרוטוקול שהושלם. ההכנה אינה חותמת או שולחת את המסמך.",
  "externalModule.egisz.prepare.openPatient": "פתיחת תיק המטופל",
  "externalModule.egisz.prepare.openSettings": "פתיחת מרכז הבקרה",
  "externalModule.egisz.prepare.addresses": "בחרו כתובת אחת או שתיים מ־GAR",
  "externalModule.egisz.prepare.identity": "מסמך זיהוי",
  "externalModule.egisz.prepare.insurance": "פוליסת ביטוח",
  "externalModule.egisz.prepare.omit": "ללא צירוף",
  "externalModule.egisz.prepare.replace": "הכנת מסמך חלופי",
  "externalModule.egisz.prepare.replacementNote": "כבר הוכן מסמך. אפשר להחליפו לפני השליחה או לאחר דחייה מאושרת. כאשר תוצאת השליחה אינה ידועה, החלפה אפשרית רק אם התשובה השמורה מאשרת דחייה. ה־XML והחתימות הקודמים נשמרים בהיסטוריה; יש לחתום מחדש על המסמך החלופי.",
  "externalModule.egisz.prepare.clinical": "השלימו את הביקור והפרוטוקול שלו, ואז רעננו את הרשימה.",
  "externalModule.egisz.prepare.protocol": "בדקו את הסיכום, תוצאת המחלה שנבחרה והאבחנות. תקנו נתונים קליניים באמצעות תהליך תיקון הרשומה.",
  "externalModule.egisz.prepare.administrative": "בדקו SNILS של המטופל והרופא, מסמכים נבחרים, כתובות GAR ו־OGRN של הארגון.",
  "externalModule.egisz.prepare.patient": "בדקו את שם המטופל, תאריך הלידה, המין וכתובות GAR שנבחרו.",
  "externalModule.egisz.prepare.author": "בדקו את שם הרופא, SNILS והתפקיד שנשמר בביקור.",
  "externalModule.egisz.prepare.workplace": "בדקו את התפקיד וההתמחות שנשמרו עבור מקום העבודה של הרופא. תיקון נתונים קליניים נעשה ברשומה הרפואית.",
  "externalModule.egisz.prepare.organization": "השלימו את השם המשפטי, הכתובת וקוד האזור ברוסיה של הארגון.",
  "externalModule.egisz.prepare.terminology": "בדקו את פרופיל המינוח הרוסי של הארגון ואת זמינות גרסאות המילונים הנדרשות.",
  "externalModule.egisz.prepare.patientIdentity": "בדקו את הזהות החיצונית של המטופל; אין להשתמש מחדש בזהות לא פעילה או ממוזגת.",
  "externalModule.egisz.prepare.validation": "המסמך שנוצר לא עבר את בדיקת חבילת SEMD. בדקו את נתוני המקור לפני הכנה חוזרת.",
  "externalModule.egisz.prepare.reloaded": "נתוני המקור העדכניים נטענו. בדקו ובחרו מחדש את הפרטים המנהליים.",
  "externalModule.egisz.mapping.title": "מיפוי שדות פרוטוקולים",
  "externalModule.egisz.mapping.hint": "בחרו גרסה שפורסמה ומפו את שדותיה למסמך הייעוץ. שדות אחרים שמולאו נשמרים בטקסט המסמך. לכל גרסה מיפוי משלה.",
  "externalModule.egisz.mapping.conclusion": "מסקנת הייעוץ",
  "externalModule.egisz.mapping.illness": "תולדות המחלה",
  "externalModule.egisz.mapping.life": "רקע אישי",
  "externalModule.egisz.mapping.outcome": "תוצאת המחלה (NSI 11.1046; נדרשת לשליחה)",
  "externalModule.egisz.mapping.visitKind": "קוד סוג הפנייה (NSI 11.1007)",
  "externalModule.egisz.mapping.supporting": "פרוטוקול נלווה זה נכלל כפרק נפרד במסמך הייעוץ הראשי, עם הכותרת והשדות שנחתמו בו.",
  "externalModule.egisz.mapping.configured": "הוגדר מיפוי לגרסת פרוטוקול זו.",
  "externalModule.egisz.mapping.missing": "יש להגדיר מיפוי שדות לגרסת הפרוטוקול לפני הכנת XML.",
  "externalModule.egisz.mapping.unsaved": "מיפוי שדות פרוטוקול EGISZ שלא נשמר",
  "externalModule.egisz.settings.stages": "ליצירת XML משמשים OID מפרטי הארגון ומזהי מערכת המידע מהגדרות אלה. כתובות נטריקה, LPU, מזהה המערכת, מפתחות ומיפויי מקומות עבודה נדרשים לשליחה. אפשר לשמור את ההגדרות בהדרגה.",
  "externalModule.egisz.documentConfiguration": "יש למלא את מספר מערכת המידע ואת מספר המופע בהגדרות EGISZ. הגדרות חיבור לנטריקה אינן נדרשות ליצירת XML.",
  "externalModule.egisz.transportConfiguration": "יש להשלים הגדרות חיבור ופרטי גישה לנטריקה לפני השליחה. מסמך XML שהוכן נשמר.",
  "externalModule.egisz.configurationInvalid": "אחד מערכי ההגדרות אינו תקין. בדקו את מבנה המזהים ואת כתובות השירות שהוזנו.",
  "externalModule.egisz.deliverySourceMissing": "לשליחה נדרשים תוצאת המחלה בפועל, התמחות הרופא ומיפוי מקום העבודה בנטריקה. יש לתקן נתונים קליניים ברשומה ולבדוק את מיפוי מקומות העבודה בהגדרות.",
  "externalModule.egisz.protocolMappingRequired": "יש להגדיר מיפוי שדות תקין לגרסת הפרוטוקול המסוימת בהגדרות EGISZ.",
  "externalModule.egisz.prepare.patientSNILS": "מזהה SNILS של המטופל חסר, שגוי או אינו חד־משמעי. בדקו את מסמכי הזיהוי שלו.",
  "externalModule.egisz.prepare.authorSNILS": "מזהה SNILS של הרופא חסר, שגוי או אינו חד־משמעי. בדקו את מסמכי הזיהוי שלו.",
  "externalModule.egisz.prepare.authorPosition": "במקום העבודה שנשמר אין תפקיד רופא תקין לפי NSI 11.1002. יש לתקן את המקור הקליני דרך הרשומה.",
  "externalModule.egisz.prepare.organizationOGRN": "יש להשלים מספר רישום OGRN של הארגון הרוסי.",
  "externalModule.egisz.prepare.conclusionMissing": "השדה שמופה למסקנת הייעוץ ריק. יש לתקן את המקור הקליני דרך הרשומה.",
  "externalModule.egisz.prepare.labelMissing": "לשדה או לערך המצוין בפרוטוקול חסר שם ברוסית הנדרש למסמך EGISZ. הוסיפו תרגום בתהליך התיקון הרגיל של הפרוטוקול או הקטלוג.",
  "externalModule.egisz.prepare.supportingInvalid": "לא ניתן לכלול את הפרוטוקול הנוסף המצוין. בדקו את הגרסה השמורה ואת הנתונים המלאים ותקנו בתהליך התיקון הקליני הרגיל.",
  "externalModule.egisz.prepare.field.authorFamily": "רופא ← שם משפחה בפרוטוקול",
  "externalModule.egisz.prepare.field.authorGiven": "רופא ← שם פרטי בפרוטוקול",
  "externalModule.egisz.prepare.field.authorName": "רופא ← שם מובנה בפרוטוקול",
  "externalModule.egisz.prepare.field.authorIdentifier": "רופא ← מזהה מטפל",
  "externalModule.egisz.prepare.field.authorPosition": "רופא ← תפקיד בפרוטוקול (NSI 11.1002)",
  "externalModule.egisz.prepare.field.authorSNILS": "רופא ← SNILS במסמכים אישיים",
  "externalModule.egisz.prepare.field.patientFamily": "מטופל ← שם משפחה בפרוטוקול",
  "externalModule.egisz.prepare.field.patientGiven": "מטופל ← שם פרטי בפרוטוקול",
  "externalModule.egisz.prepare.field.patientName": "מטופל ← שם מובנה בפרוטוקול",
  "externalModule.egisz.prepare.field.patientBirthDate": "מטופל ← תאריך לידה בפרוטוקול",
  "externalModule.egisz.prepare.field.patientSex": "מטופל ← מין בפרוטוקול",
  "externalModule.egisz.prepare.field.patientIdentifier": "מטופל ← מזהה",
  "externalModule.egisz.prepare.field.patientSNILS": "מטופל ← SNILS במסמכים אישיים",
  "externalModule.egisz.prepare.field.patientAddress": "מטופל ← כתובת GAR שנבחרה",
  "externalModule.egisz.prepare.field.patientIdentity": "מטופל ← מסמך זיהוי שנבחר",
  "externalModule.egisz.prepare.field.patientInsurance": "מטופל ← פוליסת ביטוח שנבחרה",
  "externalModule.egisz.prepare.field.organizationName": "ארגון ← שם משפטי",
  "externalModule.egisz.prepare.field.organizationAddress": "ארגון ← כתובת רשומה",
  "externalModule.egisz.prepare.field.organizationRegion": "ארגון ← קוד אזור FNS",
  "externalModule.egisz.prepare.field.organizationCountry": "ארגון ← מדינה",
  "externalModule.egisz.prepare.field.organizationLifecycle": "ארגון ← מצב פעיל",
  "externalModule.egisz.prepare.field.organizationOID": "ארגון ← OID של FRMO",
  "externalModule.egisz.prepare.field.organizationOGRN": "ארגון ← OGRN",
  "externalModule.egisz.prepare.field.conclusion": "פרוטוקול ← מסקנה",
  "externalModule.egisz.prepare.field.mainDiagnosis": "פרוטוקול ← אבחנה ראשית אחת",
  "externalModule.egisz.prepare.field.diagnoses": "פרוטוקול ← אבחנה וקידוד לאומי",
  "externalModule.egisz.prepare.field.visitKind": "מיפוי פרוטוקול ← סוג ביקור",
  "externalModule.egisz.prepare.field.careCondition": "פרוטוקול ← תנאי מתן טיפול",
  "externalModule.egisz.prepare.field.outcome": "פרוטוקול ← תוצאת המחלה",
  "externalModule.egisz.prepare.field.specialty": "רופא ← התמחות בפרוטוקול",
  "externalModule.egisz.prepare.field.allergies": "אנמנזה של המטופל ← אלרגיות ואי-סבילות",
  "externalModule.egisz.prepare.field.lifeHistory": "אנמנזה של המטופל ← היסטוריית חיים",
  "externalModule.egisz.prepare.field.terminology": "מינוח ← ערך ומהדורה במילון הלאומי",
  "externalModule.egisz.prepare.field.protocolField": "פרוטוקול ← שדה בנתיב המצוין",
  "externalModule.egisz.prepare.problem.withField": "{field}: {problem}",
  "externalModule.egisz.prepare.problem.missing": "נתון נדרש חסר או שלא ניתן לאתרו במקור שנשמר.",
  "externalModule.egisz.prepare.problem.invalid": "הערך אינו תקין למסמך EGISZ זה. יש לתקן את המקור המצוין.",
  "externalModule.egisz.prepare.problem.ambiguous": "נמצאו כמה ערכים. יש להסיר את העמימות במקור המצוין.",
  "externalModule.egisz.prepare.field.misNumber": "הגדרות EGISZ ← מספר MIS",
  "externalModule.egisz.prepare.field.misInstance": "הגדרות EGISZ ← מספר מופע MIS",
  "externalModule.egisz.prepare.field.mapping": "פרוטוקול ← מיפוי שדות של המהדורה שפורסמה",
  "externalModule.egisz.nav.label": "אזורי EGISZ",
  "externalModule.egisz.nav.documents": "מסמכים",
  "externalModule.egisz.nav.documentsDetail": "חתימה, שליחה, רישום",
  "externalModule.egisz.nav.protocols": "פרוטוקולים",
  "externalModule.egisz.nav.protocolsDetail": "ממתינים להכנת מסמך",
  "externalModule.egisz.nav.automation": "הכנה אוטומטית",
  "externalModule.egisz.nav.automationDetail": "אילו מסמכים וממתי",
  "externalModule.egisz.kind.consultation": "פרוטוקול ייעוץ",
  "externalModule.egisz.protocols.description": "ייעוצים שהושלמו ואין עדיין מסמך לגרסה הנוכחית שלהם. סמנו פרוטוקולים כדי להכין מסמכים מהנתונים העדכניים של המטופל. ההכנה אינה חותמת ואינה שולחת.",
  "externalModule.egisz.protocols.loading": "טעינת פרוטוקולים…",
  "externalModule.egisz.protocols.empty": "לכל הפרוטוקולים שהושלמו כבר יש מסמך.",
  "externalModule.egisz.protocols.protocol": "פרוטוקול",
  "externalModule.egisz.protocols.readiness": "מוכנות",
  "externalModule.egisz.protocols.prepare": "הכנת מסמכים",
  "externalModule.egisz.protocols.prepareSelected": "הכנת מסמכים ({count})",
  "externalModule.egisz.protocols.prepareManually": "הכנה עם בחירת נתונים",
  "externalModule.egisz.protocols.moreIssues": "{list} ועוד {count}",
  "externalModule.egisz.protocols.openDocuments": "פתיחת המסמכים",
  "externalModule.egisz.protocols.state.ready": "מוכן",
  "externalModule.egisz.protocols.state.unmapped": "אין מיפוי שדות",
  "externalModule.egisz.protocols.state.replacement": "נדרש מסמך חלופי",
  "externalModule.egisz.protocols.state.refused": "לא הוכן {date}",
  "externalModule.egisz.protocols.state.refusedAutomatic": "לא הוכן אוטומטית {date}",
  "externalModule.egisz.protocols.batch.waiting": "בתור",
  "externalModule.egisz.protocols.batch.preparing": "בהכנה…",
  "externalModule.egisz.protocols.batch.prepared": "הוכן",
  "externalModule.egisz.protocols.batch.issues": "יש לתקן נתונים",
  "externalModule.egisz.protocols.batch.failed": "לא הוכן",
  "externalModule.egisz.protocols.batch.progress": "בהכנה: {done} מתוך {total}…",
  "externalModule.egisz.protocols.batch.summary": "הוכנו {prepared} מתוך {total}. יש לתקן נתונים: {issues}. נכשלו: {failed}.",
  "externalModule.egisz.protocols.batch.stopped": "הופסק. הוכנו {prepared} מתוך {total}. יש לתקן נתונים: {issues}. נכשלו: {failed}.",
  "externalModule.egisz.protocols.batch.stop": "עצירה",
  "externalModule.egisz.protocols.batch.limit": "אפשר להכין עד 100 פרוטוקולים בבת אחת.",
  "externalModule.egisz.automation.description": "המערכת מכינה בעצמה את המסמך שנבחר מהפרוטוקולים שסומנו, עבור טיפולים מתאריך ההתחלה. המסמכים אינם נחתמים ואינם נשלחים אוטומטית: הם ממתינים באזור המסמכים. פרוטוקול שנתוני המטופל שלו מותירים בחירה נשאר באזור הפרוטוקולים עם הסיבה.",
  "externalModule.egisz.automation.loading": "טעינת ההכנה האוטומטית…",
  "externalModule.egisz.automation.moduleDisabled": "המודול כבוי; ההכנה האוטומטית תתחדש כשיופעל.",
  "externalModule.egisz.automation.readOnly": "שינוי ההכנה האוטומטית דורש הרשאה לנהל את מודולי המרפאה.",
  "externalModule.egisz.automation.enable": "הכנה אוטומטית",
  "externalModule.egisz.automation.savedOn": "פעיל מאז {date}. המסמכים מוכנים בשם {name}.",
  "externalModule.egisz.automation.savedOff": "כבוי. שינוי אחרון: {name}, {date}.",
  "externalModule.egisz.automation.neverSaved": "עדיין לא הוגדר.",
  "externalModule.egisz.automation.paused": "מושהה: המכין כבר אינו יכול להכין מסמכים",
  "externalModule.egisz.automation.pausedDetail": "מושהה: {name} כבר אינו יכול להכין מסמכי EGISZ (החשבון, התפקיד או רשומת המטפל השתנו). שמרו את ההגדרות מחדש כדי להפוך למכינים.",
  "externalModule.egisz.automation.startDate": "הכנה עבור טיפולים מתאריך",
  "externalModule.egisz.automation.startDateHint": "פרוטוקולים של טיפולים מוקדמים יותר נשארים באזור הפרוטוקולים להכנה ידנית.",
  "externalModule.egisz.automation.protocols": "פרוטוקולים ({chosen} מתוך {total})",
  "externalModule.egisz.automation.chooseMapped": "בחירת כל המופים",
  "externalModule.egisz.automation.chooseNone": "ניקוי הבחירה",
  "externalModule.egisz.automation.noProtocols": "במרפאה אין פרוטוקולי ייעוץ שפורסמו.",
  "externalModule.egisz.automation.unmapped": "עדיין אין מיפוי שדות: פרוטוקולים כאלה ממתינים עד שמפתח יגדיר אותו בהגדרות EGISZ.",
  "externalModule.egisz.automation.openMapping": "פתיחת הגדרות EGISZ",
  "externalModule.egisz.automation.incomplete": "כדי להפעיל הכנה אוטומטית, בחרו תאריך התחלה ולפחות פרוטוקול אחד.",
  "externalModule.egisz.automation.preparer": "לאחר השמירה המסמכים יוכנו בשם {name}.",
  "externalModule.egisz.automation.save": "שמירה",
  "externalModule.egisz.automation.discard": "ביטול השינויים",
  "externalModule.egisz.automation.saved": "נשמר.",
  "externalModule.egisz.automation.unsaved": "הגדרות הכנה אוטומטית שלא נשמרו",
  "externalModule.egisz.automation.configure": "הגדרה",
  "externalModule.egisz.automation.stripOn": "הכנה אוטומטית של „{document}”: פעילה",
  "externalModule.egisz.automation.stripOff": "הכנה אוטומטית של „{document}”: כבויה",
  "externalModule.egisz.automation.stripScope": "טיפולים מ־{date}, פרוטוקולים: {count}",
  "externalModule.egisz.automation.authorityRequired": "רק משתמש שיכול להכין מסמכי EGISZ ויש לו רשומת מטפל יכול להפעיל הכנה אוטומטית.",
  "externalModule.egisz.automation.protocolUnavailable": "אחד הפרוטוקולים שנבחרו אינו זמין עוד. טענו מחדש את ההגדרות.",
  "externalModule.egisz.replace.action": "הכנת מסמך חלופי",
  "externalModule.egisz.replace.superseded": "כבר קיימת גרסה חדשה יותר של המסמך. פתחו את הגרסה האחרונה מהרשימה.",
  "externalModule.egisz.replace.unavailable": "הפרוטוקול אינו זמין עוד להכנה.",
  "externalModule.egisz.signing.validTo": "עד {to}",
  "externalModule.egisz.signing.validity": "בתוקף מ־{from} עד {to}",
  "externalModule.egisz.signing.notOnWorkstation": "לא בתחנת העבודה הזאת",
  "externalModule.egisz.signing.noCertificates": "אין תעודות חתימה בתחנת העבודה הזאת",
  "externalModule.egisz.sendNeedsSignatures": "נדרשות תחילה חתימת הרופא וחתימת הארגון.",
  "externalModule.egisz.batch.sign": "חתימה על הנבחרים",
  "externalModule.egisz.batch.asDoctor": "כרופא",
  "externalModule.egisz.batch.asOrganization": "בשם הארגון",
  "externalModule.egisz.batch.cancel": "ביטול חתימה",
  "externalModule.egisz.batch.doctor": "של הרופא",
  "externalModule.egisz.batch.organization": "של הארגון",
}
